import React from 'react';

const SvgExclamationPointIcon = (props) => (
  <svg
    viewBox="0 0 10 10"
    width="1em"
    height="1em"
    {...props}
    id="ExclamationPointIcon">
    <path
      d="M5 .1C2.3.1.1 2.3.1 5S2.3 9.9 5 9.9 9.9 7.7 9.9 5 7.7.1 5 .1zm.6 8.6c0 .1-.1.1-.1.2s-.2.2-.3.2H5c-.1 0-.2 0-.3-.1s-.1 0-.2 0-.1-.2-.1-.3-.1-.1-.1-.2 0-.2.1-.3.1-.1.1-.2.1-.1.2-.1H5c.1 0 .2 0 .2.1s.2 0 .3 0 .1.1.1.2.1.2.1.2c-.1.2-.1.3-.1.3zm.1-6.8v.2l-.6 4.8h-.2l-.5-4.8v-.5c0-.1 0-.2.1-.3s.1-.2.1-.3.1 0 .1-.1.2 0 .3 0c.2 0 .3.1.5.2s.2.4.2.7v.1z"
      fill="currentColor"
    />
  </svg>
);

export default SvgExclamationPointIcon;
